
// Project Module State
const state = {
  fetching: false,
  token: null,
  user: {},
  googleAuthenticated: false,
  googleUser: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/auth/state.js